import React, { useEffect } from 'react';
import $ from 'jquery';
import { IProps } from './types';
import useOutsideClick from 'constants/hooks/useOutsideClick';

const styles: { [key: string]: React.CSSProperties } = {
  item: {
    cursor: 'pointer'
  },
  panel: {
    zIndex: 99
  }
};

const FunctionsItem01: React.FC<IProps> = (props) => {
  /**
   * @description 實作 hover 效果
   */
  useEffect(() => {
    const elem = $(`#${props.id}`);
    if (elem) {
      elem.on('mouseenter', addActiveClass);
      elem.on('mouseleave', removeActiveClass);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      if (elem) {
        elem.off('mouseenter', addActiveClass);
        elem.off('mouseleave', removeActiveClass);
      }
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  /**
   * @description 針對目標元素加入 active 樣式類別
   */
  const addActiveClass = () => {
    const elem = $(`#${props.id}`);
    if (elem) elem.addClass('active');
  };

  /**
   * @description 針對目標元素移除 active 樣式類別
   */
  const removeActiveClass = () => {
    const elem = $(`#${props.id}`);
    if (elem) elem.removeClass('active');
  };

  /**
   * @description 點擊外部區域
   */
  const ref = useOutsideClick(() => {
    props.onActive(false);
  });

  /**
   * @description 處理選單 onClick 執行的事件
   */
  const handleClick = () => {
    props.onActive(!props.isActive);
  };

  /**
   * @description 處理視窗大小變動執行的事件
   */
  const handleResize = () => {
    props.onActive(false);
  };

  return (
    <div style={styles.item} id={props.id} ref={ref} className={'header__functions-item' + (props.isActive ? ' active' : '')}>
      <div className={['header__functions-btn', props.btnClassName ?? ''].join(' ')} onClick={handleClick}>
        {props.text ? (
          <span>{props.text}</span>
        ) : null}
      </div>
      <div style={styles.panel} className="header__dropdown">
        <div className="header__dropdown-wrapper">
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default FunctionsItem01;
